"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const generateRandomPassword = () => {
    const lowercase = 'abcdefghijklmnopqrstuvwxyz';
    const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numbers = '0123456789';
    const symbols = '@#$%^&*!';
    // Ensure at least one of each character type
    const randomLower = lowercase[Math.floor(Math.random() * lowercase.length)];
    const randomUpper = uppercase[Math.floor(Math.random() * uppercase.length)];
    const randomNumber = numbers[Math.floor(Math.random() * numbers.length)];
    const randomSymbol = symbols[Math.floor(Math.random() * symbols.length)];
    // Generate remaining characters
    const remainingLength = 8;
    const allChars = lowercase + uppercase + numbers + symbols;
    let remainingChars = '';
    for (let i = 0; i < remainingLength - 4; i++) {
        remainingChars += allChars[Math.floor(Math.random() * allChars.length)];
    }
    // Combine all parts and shuffle
    const password = randomUpper + randomLower + randomNumber + randomSymbol + remainingChars;
    return password.split('').sort(() => Math.random() - 0.5).join('');
};
exports.default = generateRandomPassword;
